import React, { HTMLAttributes, useMemo } from "react";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import { Hooks } from "@xt/xtbase";
const { useTranslation } = Hooks;
import store from "store";
import { routerPush } from "utils/method";

import XtTabs from "components/xt/tabs";

import { TypeEnum } from "store/market";

const Main: React.FC<HTMLAttributes<HTMLDivElement>> = ({ children }) => {
  const t = useTranslation();
  const router = useRouter();
  const { name, type, leverConfigObj } = store.market;

  const items = useMemo(() => {
    const ary = [
      {
        key: TypeEnum.spot,
        label: t("trade.spot"),
      },
    ];
    if (leverConfigObj && leverConfigObj[name]) {
      ary.push({
        key: TypeEnum.lever,
        label: t("trade.margin") + " " + leverConfigObj[name].maxLeverage + "x",
      });
    }
    return ary;
  }, [name, leverConfigObj]);

  const handleChange = (key) => {
    routerPush(router, { symbol: name, isLever: key === TypeEnum.lever });
  };

  return (
    <XtTabs activeKey={type} items={items} onChange={handleChange}>
      {children}
    </XtTabs>
  );
};

export default observer(Main);
